import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';

// Safety net for the page content area. Several pre-existing pages read
// i18n keys that are missing from translation.json (a defect that
// predates this change and spans well beyond it — see PR notes); without
// a boundary, a render error there unmounts the whole app to a blank
// white screen. This keeps the header/footer chrome intact and gives the
// visitor a way back instead.
export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Route render error', error, info);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.locationKey !== this.props.locationKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <Container maxWidth="sm" sx={{ py: { xs: 8, md: 12 }, textAlign: 'center' }}>
          <Typography sx={{ fontFamily: 'var(--font-serif)', fontSize: '2rem', mb: 2 }}>
            This page couldn&apos;t load
          </Typography>
          <Typography sx={{ color: 'text.secondary', mb: 4 }}>
            Something went wrong rendering this page. Please try again, or head back to the homepage.
          </Typography>
          <Box>
            <Button variant="contained" href="/">
              Back to homepage
            </Button>
          </Box>
        </Container>
      );
    }
    return this.props.children;
  }
}
